import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const FixedAssets = () => {
  return <ErpTablePage moduleKey="fixed_assets" />;
};

export default FixedAssets;